import { createSelector } from 'reselect';

const selectLicenses = (state: any) => state.licenses;


export const selectLicensesCurrentItem = createSelector([selectLicenses], (licenses) => licenses.current);

export const selectLicensesListItems = createSelector([selectLicenses], (licenses) => licenses.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectLicensesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectLicensesQueryItems = createSelector([selectLicenses], (licenses) => licenses.query);

export const selectLicensesCreatedItem = createSelector([selectLicenses], (licenses) => licenses.create);

export const selectLicensesUpdatedItem = createSelector([selectLicenses], (licenses) => licenses.update);

export const selectLicensesReadItem = createSelector([selectLicenses], (licenses) => licenses.read);

export const selectLicensesDeletedItem = createSelector([selectLicenses], (licenses) => licenses.delete);

export const selectLicensesSearchedItems = createSelector([selectLicenses], (licenses) => licenses.search);

export const selectLicensesItemsCount = createSelector([selectLicenses], (licenses) => licenses.count);

export const selectLicensesItemsFilter = createSelector([selectLicenses], (licenses) => licenses.filter);